import { cn } from "@/web/lib/styling";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div data-slot="skeleton" className={cn("animate-pulse bg-accent", className)} {...props} />
  );
}

export { Skeleton };
